import type { LucideIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

type StatKpiCardProps = {
  title: string;
  value: string | number;
  description?: string;
  icon: LucideIcon;
  gradient: string;
  className?: string;
};

export function StatKpiCard({
  title,
  value,
  description,
  icon: Icon,
  gradient,
  className,
}: StatKpiCardProps) {
  return (
    <Card className={cn('thms-stat-card', className)}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-artis-slate">{title}</CardTitle>
        <div className={cn('rounded-xl bg-gradient-to-br p-2.5 shadow-sm', gradient)}>
          <Icon className="h-4 w-4 text-white" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold tabular-nums text-artis-brown-dark">{value}</div>
        {description ? <p className="mt-1 text-xs text-artis-slate">{description}</p> : null}
      </CardContent>
    </Card>
  );
}
